"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PandaDocConfigOutSerializer = void 0;
exports.PandaDocConfigOutSerializer = {
    _fromJsonObject(object) {
        return {};
    },
    _toJsonObject(self) {
        return {};
    },
};
//# sourceMappingURL=pandaDocConfigOut.js.map